import { get, post, put } from "../common/apiClient";

const PATH_USER = "/user";

const getUserInfoById = async () => {
  return await get(PATH_USER + "/user-info");
};
const updatePassword = async (password) => {
  return await put(PATH_USER + "/update-password", { password });
};
const updateInfoUser = async (body) => {
  return await put(PATH_USER + "/update-info-user", body);
};

const checkPremiumAccount = async () => {
  return await get(PATH_USER + "/check-premium");
};

const checkUserBuyCourse = async (examRoomId = null, assessmentId = null) => {
  const params = new URLSearchParams();
  if (examRoomId) params.append("examRoomId", examRoomId);
  if (assessmentId) params.append("assessmentId", assessmentId);

  const query = `/course/check-user-buy-course?${params.toString()}`;
  return await get(query);
};

const updateScore = async (body) => {
  return await put(PATH_USER + "/update-score", body);
};
export {
  getUserInfoById,
  updatePassword,
  updateInfoUser,
  checkPremiumAccount,
  checkUserBuyCourse,
  updateScore,
};
